/*! smooth-scroll v7.1.0 | (c) 2015 Chris Ferdinandi | MIT License | http://github.com/cferdinandi/smooth-scroll */
/* eslint-disable */
!(function(e, t) {
  "function" == typeof define && define.amd
    ? define([], t(e))
    : "object" == typeof exports
    ? (module.exports = t(e))
    : (e.smoothScroll = t(e));
})("undefined" != typeof global ? global : this.window || this.global, function(
  e
) {
  "use strict";
  var t,
    n,
    r,
    o,
    a = {},
    u = "querySelector" in document && "addEventListener" in e,
    c = {
      selector: "[data-scroll]",
      selectorHeader: "[data-scroll-header]",
      speed: 500,
      easing: "easeInOutCubic",
      offset: 0,
      updateURL: !0,
      callback: function() {}
    },
    i = function() {
      let e = {},
        t = !1,
        n = 0,
        r = arguments.length;
      "[object Boolean]" === Object.prototype.toString.call(arguments[0]) &&
        ((t = arguments[0]), n++);
      for (
        let o = function(n) {
          for (const r in n)
            Object.prototype.hasOwnProperty.call(n, r) &&
              (t && "[object Object]" === Object.prototype.toString.call(n[r])
                ? (e[r] = i(!0, e[r], n[r]))
                : (e[r] = n[r]));
        };
        r > n;
        n++
      ) {
        const a = arguments[n];
        o(a);
      }
      return e;
    },
    s = function(e) {
      return Math.max(e.scrollHeight, e.offsetHeight, e.clientHeight);
    },
    l = function(e, t) {
      let n,
        r,
        o = t.charAt(0),
        a = "classList" in document.documentElement;
      for (
        "[" === o &&
        ((t = t.substr(1, t.length - 2)),
        (n = t.split("=")),
        n.length > 1 &&
          ((r = !0), (n[1] = n[1].replace(/"/g, "").replace(/'/g, ""))));
        e && e !== document;
        e = e.parentNode
      ) {
        if ("." === o)
          if (a) {
            if (e.classList.contains(t.substr(1))) return e;
          } else if (
            new RegExp("(^|\\s)" + t.substr(1) + "(\\s|$)").test(e.className)
          )
            return e;
        if ("#" === o && e.id === t.substr(1)) return e;
        if ("[" === o && e.hasAttribute(n[0])) {
          if (!r) return e;
          if (e.getAttribute(n[0]) === n[1]) return e;
        }
        if (e.tagName.toLowerCase() === t) return e;
      }
      return null;
    },
    f = function(e) {
      for (
        var t, n = String(e), r = n.length, o = -1, a = "", u = n.charCodeAt(0);
        ++o < r;

      ) {
        if (((t = n.charCodeAt(o)), 0 === t))
          throw new InvalidCharacterError(
            "Invalid character: the input contains U+0000."
          );
        a +=
          (t >= 1 && 31 >= t) ||
          127 == t ||
          (0 === o && t >= 48 && 57 >= t) ||
          (1 === o && t >= 48 && 57 >= t && 45 === u)
            ? "\\" + t.toString(16) + " "
            : t >= 128 ||
              45 === t ||
              95 === t ||
              (t >= 48 && 57 >= t) ||
              (t >= 65 && 90 >= t) ||
              (t >= 97 && 122 >= t)
            ? n.charAt(o)
            : "\\" + n.charAt(o);
      }
      return a;
    },
    d = function(e, t) {
      let n;
      return (
        "easeInQuad" === e && (n = t * t),
        "easeOutQuad" === e && (n = t * (2 - t)),
        "easeInOutQuad" === e &&
          (n = 0.5 > t ? 2 * t * t : -1 + (4 - 2 * t) * t),
        "easeInCubic" === e && (n = t * t * t),
        "easeOutCubic" === e && (n = --t * t * t + 1),
        "easeInOutCubic" === e &&
          (n =
            0.5 > t ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1),
        "easeInQuart" === e && (n = t * t * t * t),
        "easeOutQuart" === e && (n = 1 - --t * t * t * t),
        "easeInOutQuart" === e &&
          (n = 0.5 > t ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t),
        "easeInQuint" === e && (n = t * t * t * t * t),
        "easeOutQuint" === e && (n = 1 + --t * t * t * t * t),
        "easeInOutQuint" === e &&
          (n = 0.5 > t ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t),
        n || t
      );
    },
    m = function(e, t, n) {
      let r = 0;
      if (e.offsetParent)
        do (r += e.offsetTop), (e = e.offsetParent);
        while (e);
      return (r = r - t - n), r >= 0 ? r : 0;
    },
    h = function() {
      return Math.max(
        e.document.body.scrollHeight,
        e.document.documentElement.scrollHeight,
        e.document.body.offsetHeight,
        e.document.documentElement.offsetHeight,
        e.document.body.clientHeight,
        e.document.documentElement.clientHeight
      );
    },
    p = function(e) {
      return e && "object" == typeof JSON && "function" == typeof JSON.parse
        ? JSON.parse(e)
        : {};
    },
    g = function(t, n) {
      e.history.pushState &&
        (n || "true" === n) &&
        e.history.pushState(
          null,
          null,
          [
            e.location.protocol,
            "//",
            e.location.host,
            e.location.pathname,
            e.location.search,
            t
          ].join("")
        );
    },
    b = function(e) {
      return null === e ? 0 : s(e) + e.offsetTop;
    };
  a.animateScroll = function(t, n, a) {
    var u = p(t ? t.getAttribute("data-options") : null),
      s = i(s || c, a || {}, u);
    n = "#" + f(n.substr(1));
    const l =
        "#" === n ? e.document.documentElement : e.document.querySelector(n),
      v = e.pageYOffset;
    r || (r = e.document.querySelector(s.selectorHeader)), o || (o = b(r));
    let y,
      O,
      S,
      I = m(l, o, parseInt(s.offset, 10)),
      H = I - v,
      E = h(),
      L = 0;
    g(n, s.updateURL);
    const j = function(r, o, a) {
        const u = e.pageYOffset;
        (r == o || u == o || e.innerHeight + u >= E) &&
          (clearInterval(a), l.focus(), s.callback(t, n));
      },
      w = function() {
        (L += 16),
          (O = L / parseInt(s.speed, 10)),
          (O = O > 1 ? 1 : O),
          (S = v + H * d(s.easing, O)),
          e.scrollTo(0, Math.floor(S)),
          j(S, I, y);
      },
      C = function() {
        y = setInterval(w, 16);
      };
    0 === e.pageYOffset && e.scrollTo(0, 0), C();
  };
  const v = function(e) {
      const n = l(e.target, t.selector);
      n &&
        "a" === n.tagName.toLowerCase() &&
        (e.preventDefault(), a.animateScroll(n, n.hash, t));
    },
    y = function(e) {
      n ||
        (n = setTimeout(function() {
          (n = null), (o = b(r));
        }, 66));
    };
  return (
    (a.destroy = function() {
      t &&
        (e.document.removeEventListener("click", v, !1),
        e.removeEventListener("resize", y, !1),
        (t = null),
        (n = null),
        (r = null),
        (o = null));
    }),
    (a.init = function(n) {
      u &&
        (a.destroy(),
        (t = i(c, n || {})),
        (r = e.document.querySelector(t.selectorHeader)),
        (o = b(r)),
        e.document.addEventListener("click", v, !1),
        r && e.addEventListener("resize", y, !1));
    }),
    a
  );
});
/* eslint-enable */
